<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.rematchFailTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <ul class="rb-match-outcome-bullets">
        <li>{{ $t('intake.rematchFailBulletNoSafe') }}</li>
        <li>{{ $t('intake.rematchFailBulletUnchanged') }}</li>
        <li>{{ $t('intake.rematchFailBulletRetryLater') }}</li>
      </ul>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="backToCare">
        {{ $t('intake.rematchBackToCareAction') }}
      </button>
      <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="retry">
        {{ $t('intake.rematchRetryAction') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RematchFailStep',
  methods: {
    backToCare() {
      this.$router.push({
        name: 'dashboard',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
    retry() {
      this.$router.push({
        name: 'intakeRematchRun',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
